import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-pretty-check',
  templateUrl: './pretty-check.component.html',
  styleUrls: ['./pretty-check.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class PrettyCheckComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/features/pretty-check/pretty-check.component.ts